import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output
} from '@angular/core';
import { Toast } from 'primeng/toast';
import { PrimeTemplate } from 'primeng/api';
import { MButtonComponent } from '../m-button/m-button.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-toast',
  templateUrl: './m-toast.component.html',
  styleUrls: ['./m-toast.component.scss'],
  imports: [Toast, PrimeTemplate, MButtonComponent]
})
export class MToastComponent {
  @Input() position = 'top-center';
  @Input() baseZIndex = 35000;

  readonly actionClick = output<string>();

  navigateToContactSupportPage(): void {
    window.open('https://measured.atlassian.net/servicedesk/customer/portal/2');
  }

  refreshPage(): void {
    window.location.reload();
  }

  emitButtonAction(actionId: string) {
    this.actionClick.emit(actionId);
  }
}
